module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Profil.f44e3095.svg";